import React from 'react';
import styled from '@emotion/styled';
import { Inducer } from 'src/components';


const Component: React.FCX = ({ className }) => {
  return (
    <>
      <Inducer from='var(--color-primary-light)' to='var(--color-secondary-light)' />
      <Inducer from='var(--color-secondary-light)' to='var(--color-primary-light)' />
    </>
  );
};

const StyledComponent = styled(Component)`
  color: var(--color-text-inverse);
  font-size: 1.8rem;
  line-height: 1.4em;
  min-height: 60vh;
  width: 100%;
`;

export default StyledComponent;
